i<template>
<div class="linkcard">
  <v-card
  raised
  elevation="10"
  v-if="twigene.account"
  >
    <router-link v-bind:to="{name: 'UserPage',
      params: {screen_name: twigene.account}}">
    <v-card-title class="card__title">
      <h3>{{ formatedTitle }}</h3>
        </v-card-title>
        <v-card-text class="card__text">
          <h6 class="grey--text">{{ formatedDescription }}</h6>
        </v-card-text>
    <v-card-actions class="card__actions">
      <div class="released__time">
      {{ releasedAtFromNow }}
      </div>
      <v-spacer></v-spacer>
      <v-btn
      v-if="userinfo && userinfo.screenName==twigene.account"
      text
      @click.prevent="PostingTweet"
      :disabled="processing"
      :loading="processing"
      >
        <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
      </v-btn>
      <!-- <v-btn icon>
        <font-awesome-icon
            class="fotter__menu__icon"
            :icon="['far', 'heart']">
        </font-awesome-icon>
      </v-btn>
      <v-btn icon>
        <font-awesome-icon
            class="fotter__menu__icon"
            :icon="['fas', 'retweet']">
        </font-awesome-icon>
      </v-btn> -->
    </v-card-actions>
    </router-link>
  </v-card>
  <v-card
  raised
  elevation="10"
  v-else
  >
    <v-card-title class="card__title">
      <h3>{{ formatedTitle }}</h3>
        </v-card-title>
        <v-card-text class="card__text">
          <h6 class="grey--text">{{ formatedDescription }}</h6>
        </v-card-text>
    <v-card-actions class="card__actions">
      <div class="released__time">
      {{ releasedAtFromNow }}
      </div>
      <v-spacer></v-spacer>
      <v-btn
      v-if="userinfo"
      text
      @click.prevent="PostingTweet"
      :disabled="processing"
      :loading="processing"
      >
        <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
      </v-btn>
      <!-- <v-btn icon>
        <font-awesome-icon
            class="fotter__menu__icon"
            :icon="['far', 'heart']">
        </font-awesome-icon>
      </v-btn>
      <v-btn icon>
        <font-awesome-icon
            class="fotter__menu__icon"
            :icon="['fas', 'retweet']">
        </font-awesome-icon>
      </v-btn> -->
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import axios from 'axios'
import CONSTANT from '../components/constants/index'
export default {
  name: 'TwigeneCard',
  data () {
    return {
      tweets: [],
      pageNumber: 1,
      perPage: 15,
      releasedAtFromNow: this.getReleasedAtFromNow(),
      processing: false
    }
  },
  methods: {
    PostingTweet (btn) {
      if (this.processing) return
      this.processing = true
      // POST送信する
      this.TweetPost()
      axios.post(
        CONSTANT.SLACK_TWEET,
        JSON.stringify({
          text: this.twigene.generated_text,
          username: this.userinfo.screenName
        }),
        {
        withCredentials: false,
        transformRequest: [(data, headers) => {
          delete headers.common.Authorization
          delete headers.post["Content-Type"]
          return data
        }]
      }).catch(err => {
          console.log("error: ", err)
          this.processing = false
        })
    },
    createTweetUrl () {
      // Twitter用のurl作成
      const url = encodeURIComponent(location.href) + "%0A"
      const hashTags = encodeURI('ついじぇね,自分bot')
      var createAt = this.$moment(this.twigene.created_at.valueOf()).format("YYYY/MM/DD, hh:mm:ss")
      if (this.twigene.created_at.toString() === "Invalid Date") {
        var generatedText = encodeURI(this.twigene.generated_text)
      } else {
        // var generatedText = encodeURI(this.twigene.generated_text) +"%0A"+ encodeURI(createAt + "に生成したよ")
        var generatedText = encodeURI(this.twigene.generated_text)
        
      }
      this.tweetUrl = 'https://twitter.com/intent/tweet?text=' + generatedText + "%0A%0A%23ついじぇね%20%23自分bot%0A" + '&url=' + url
      return this.tweetUrl
    },
    TweetPost () {
      if (!this.processing) {
        return
        }
      this.processing = true
      const tweetPage = this.createTweetUrl()
      if (!window.open(tweetPage)) {
        window.location.href = tweetPage
      } else {
        window.open(tweetPage)
      }
      this.processing = false
    },
    getReleasedAtFromNow () {
      if (!this.twigene || !this.twigene.created_at) {
        return ''
      }
      if (this.twigene.created_at.toString() === "Invalid Date") {
        return ''
      }
      // return this.twigene.created_at.toString()
      return this.$moment(this.twigene.created_at.valueOf()).format("YYYY/MM/DD, HH:mm:ss")
    },
    getOmissionAndPlusMidpoint (str, limit) {
      if (str.length < limit) {
        return str
      }
      return str.substr(0, limit) + '...'
    }
  },
  moutend () {
    // releasedAtFromNowを1分ごとに更新する
    // window.setInerval(() => {
    //   this.releasedAtFromNow = this.getReleasedAtFromNow()
    // }, 1000 * 60)
  },
  props: {
    'twigene': {
      type: Object,
      required: true
    }
  },
  computed: {
    formatedTitle () {
      if (!this.twigene || !this.twigene.account) {
        return ''
      }
      return this.getOmissionAndPlusMidpoint(this.twigene.account, 16)
    },
    formatedDescription () {
      if (!this.twigene || !this.twigene.generated_text) {
        return ''
      }
      return this.getOmissionAndPlusMidpoint(this.twigene.generated_text, 60)
    },
    userinfo () {
      return this.$store.getters['auth/user']
    },
    userdata () {
      return this.$store.getters['user/userProfile']
    }
  },
  watch: {
    'twigene_now' (n, o) {
    }
  }
}
</script>
<style>
.linkcard {
  margin: auto;
  display: grid;
  width: 100%;
  height: fit-content;
}
.card__title {
  padding-top:5px;
  padding-bottom: 5px;
  color:#000;
}
.card__text {
  padding-top:1px;
  padding-bottom: 5px;
}
.card__actions {
  padding:0px;
}
.released__time {
  padding:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/TwigeneCard.vue